<script>
import { format, parseISO } from 'date-fns';

export default{
  name: "KnowledgeCard",
  props: {
    item: {
      type: Object,
      required: true
    },
  },
  data(){
    return{
      itemId: this.item.id,
    }
  },
  methods: {
    formatDate(date){
      if (!date) return "N/A";
      const isoDate = parseISO(date);
      const formatted = format(isoDate, "dd/MM/yyyy, hh:mm a");
      return formatted
    }
  }
}
</script>

<template>
<div
  class="w-full rounded-xl p-5 shadow-sm flex flex-col gap-4 relative group
         bg-white border border-slate-200 hover:shadow-md hover:border-slate-300
         dark:bg-slate-800 dark:border-slate-600 dark:hover:border-slate-500
         transition"
>
  <!-- Header -->
  <div class="flex items-start justify-between">
    <div class="flex gap-4 items-center">
      <!-- File Icon -->
      <div class="w-14 h-14 rounded-lg flex items-center justify-center 
                  bg-slate-100 text-slate-400 
                  dark:bg-slate-700 dark:text-slate-300">
        <fluent-icon icon="document" class="h-8 w-8" />
      </div>

      <!-- Title & Status -->
      <div>
        <h1 class="font-semibold text-lg text-slate-800 dark:text-slate-100 truncate max-w-xs">
          {{ item.title }}
        </h1>
        <span
          class="inline-block mt-1 px-2 py-0.5 rounded-full text-xs font-medium"
          :class="{
            'bg-green-100 text-green-700 dark:bg-green-800/40 dark:text-green-300': item.sync_status === 'synced',
            'bg-yellow-100 text-yellow-700 dark:bg-yellow-800/40 dark:text-yellow-300': item.sync_status === 'processing',
            'bg-woot-100 text-woot-700 dark:bg-woot-800/40 dark:text-woot-300': item.sync_status === 'pending',
            'bg-slate-100 text-slate-700 dark:bg-slate-800/40 dark:text-slate-300': item.sync_status === 'queued',
            'bg-red-100 text-red-700 dark:bg-red-800/40 dark:text-red-300': item.sync_status === 'error',
          }"
        >
          {{ item.sync_status.toUpperCase() }}
        </span>
      </div>
    </div>

    <!-- Hover Actions -->
    <div
      class="flex gap-2 opacity-0 group-hover:opacity-100 transition-opacity"
    >
      <a :href="item.presigned_file_url" download target="_blank" @click.stop>
        <woot-button
          variant="clear"
          icon="download"
          size="small"
          class="hover:bg-slate-100 dark:hover:bg-slate-700 rounded-full"
        />
      </a>
      <woot-button
        @click.stop="$emit('delete', item)"
        variant="clear"
        icon="delete"
        size="small"
        color-scheme="alert"
        class="hover:bg-red-50 dark:hover:bg-red-800 rounded-full"
      />
    </div>
  </div>

  <!-- Details -->
  <div class="grid grid-cols-2 gap-x-6 gap-y-1 text-sm">
    <p class="text-slate-600 dark:text-slate-400">
      Last sync: <span class="font-medium">{{ formatDate(item.last_sync_at) }}</span>
    </p>
    <p class="text-slate-600 dark:text-slate-400 col-span-2">
      Created: <span class="font-medium">{{ formatDate(item.created_at) }}</span>
    </p>
    <p class="text-slate-600 dark:text-slate-300">
      Retry Count: <span class="font-medium">{{ item.retry_count }}</span>
    </p>
  </div>

  <!-- Error Message -->
  <p
    v-if="item.error_message"
    class="text-sm text-red-600 dark:text-red-300 mt-2 border-t pt-2 border-red-200 dark:border-red-700/50"
  >
    {{ item.error_message }}
  </p>
</div>
</template>
